import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Spinner } from 'react-bootstrap'
import eula from '../media/EULA.pdf'

export default function EULA() {

    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setTimeout(() => setLoading(false), 300)
    }, [])

    return (
        <>
            {loading === false ? (
                <Container fluid>
                    <div className='greyHeader'>
                        <h1>TDACS End-User License Agreement</h1>
                    </div>
                    <Container>
                        <Row className='paddingTop'>
                            <Col>
                                <iframe className='pdf' title='TDACS EULA PDF' src={`${eula}#view=fitH`} />
                            </Col>
                        </Row>
                    </Container>
                </Container>
            ) : (
                <Spinner animation='border' role='status' className='spinner'>
                    <span className='invisible'>Loading...</span>
                </Spinner>
            )}
        </>
    )
}